module.exports = __webpack_public_path__ + "static/media/pic_Isheni.7ac48c76.jpg";